
























































import { Component, Prop, Provide, Vue, Watch } from "vue-property-decorator";
import { routeInfo } from "@/config/host.config";

import RouteInfoV2CityList from "./list/RouteInfoV2CityList.vue";
import RouteInfoV2CityModal from "./list/RouteInfoV2CityModal.vue";
import RouteInfoV2RouteList from "./list/RouteInfoV2RouteList.vue";
import RouteInfoV2RouteModal from "./list/RouteInfoV2RouteModal.vue";
import RouteInfoV2AddCity from "./add/route-info-v2-add-city.vue";
import RouteInfoV2AddRoute from "./add/route-info-v2-add-route.vue";

import type { CityFeature } from "@/@types/route-info/v2/v2.citys";
import type { AxiosResponse } from "axios";
import type { Route } from "@/@types/route-info/v2/v2.routes";

@Component({
  components: {
    RouteInfoV2AddCity,
    RouteInfoV2CityList,
    RouteInfoV2CityModal,
    RouteInfoV2RouteList,
    RouteInfoV2RouteModal,
    RouteInfoV2AddRoute,
  },
})
class RouteInfoV2 extends Vue {
  @Prop({ type: String, default: "route" }) readonly listVariant!: string;
  @Provide("routeFolder") routeFolder = "routeInfo/v2/routes";
  @Provide("cityFolder") cityFolder = "routeInfo/v2/citys";

  routes: Route[] = [];
  citis: CityFeature[] = [];

  city_delited = false;
  route_delited = false;
  isActivating = false;
  activateCancel: AbortController | null = null;

  city_id = "";
  route_id = "";

  get city(): CityFeature | null {
    return this.citis.find((el) => el._id === this.city_id) || null;
  }
  get route(): Route | null {
    return this.routes.find((el) => el._id === this.route_id) || null;
  }

  get editCityItem(): CityFeature | null {
    return this.citis.find((el) => el._id === this.city_id) || null;
  }
  get editRouteItem(): Route | null {
    return this.routes.find((el) => el._id === this.route_id) || null;
  }

  mounted(): void {
    this.fetchCities();
    this.fetchRoutes();
  }

  public openCityAddModal(): void {
    this.city_id = "";
    this.$nextTick(() => this.$bvModal.show("route-info-v2-add-city"));
  }
  public openRouteAddModal(): void {
    this.route_id = "";
    this.$nextTick(() => this.$bvModal.show("route-info-v2-add-route"));
  }

  public cityOpen(id: string): void {
    this.route_id = "";
    this.city_id = id;
    this.$nextTick(() => this.$bvModal.show("route-info-v2-city-modal"));
  }
  public routeOpen(id: string): void {
    this.city_id = "";
    this.route_id = id;
    this.$nextTick(() => this.$bvModal.show("route-info-v2-route-modal"));
  }

  public routeEdit(id: string): void {
    this.city_id = "";
    this.route_id = id;
    this.$nextTick(() => this.$bvModal.show("route-info-v2-add-route"));
  }

  public cityEdit(id: string): void {
    this.route_id = "";
    this.city_id = id;
    this.$nextTick(() => this.$bvModal.show("route-info-v2-add-city"));
  }

  public toggleTrash(): void {
    if (this.listVariant === "route") {
      this.route_delited = !this.route_delited;
    } else {
      this.city_delited = !this.city_delited;
    }
  }

  // --- Fetch ---

  @Watch("route_delited")
  private async fetchRoutes(): Promise<void> {
    const uri = routeInfo.v2.routes;
    const params = { deleted: this.route_delited };
    try {
      const res = await this.$axios.get(uri, { params });
      if (res.status === 200) {
        this.routes = res.data;
      }
    } catch (e) {
      console.error(e);
    }
  }

  @Watch("city_delited")
  private async fetchCities(): Promise<void> {
    const uri = routeInfo.v2.cities;
    const params = { deleted: this.city_delited };

    try {
      const res: AxiosResponse<CityFeature[]> = await this.$axios.get(uri, {
        params,
      });
      if (res.status === 200) this.citis = res.data;
    } catch (e) {
      console.error(e);
    }
  }

  // --- Save ---

  public async saveCity(city: CityFeature): Promise<void> {
    const uri = routeInfo.v2.cities;

    try {
      const res: AxiosResponse<CityFeature> = city._id
        ? await this.$axios.put(`${uri}/${city._id}`, city)
        : await this.$axios.post(uri, city);
      if (res.status !== 200) return;
      this.$bvModal.hide("route-info-v2-add-city");
      if (city._id) {
        const index = this.citis.findIndex((c) => c._id === city._id);
        if (index !== -1) {
          this.$set(this.citis, index, res.data);
        } else this.fetchCities();
      } else {
        this.citis.push(res.data);
      }
    } catch (e) {
      console.error(e);
    }
  }

  public async saveRoute(route: Route): Promise<void> {
    const uri = routeInfo.v2.routes;

    try {
      const res: AxiosResponse<Route> = route._id
        ? await this.$axios.put(`${uri}/${route._id}`, route)
        : await this.$axios.post(uri, route);
      if (res.status !== 200) return;
      this.$bvModal.hide("route-info-v2-add-route");

      if (route._id) {
        const index = this.routes.findIndex((r) => r._id === route._id);
        if (index !== -1) {
          this.$set(this.routes, index, res.data);
        } else this.fetchRoutes();
      } else {
        this.routes.push(res.data);
      }
    } catch (e) {
      console.error(e);
    }
  }

  // --- Soft delete (move to trash) ---

  public async deleteRoute(id: string): Promise<void> {
    const confirmed = await this.$bvModal.msgBoxConfirm(
      String(this.$t("route_info.confirm.deleteRoute")),
      { title: String(this.$t("route_info.confirm.title")) }
    );
    if (confirmed !== true) return;
    try {
      const res: AxiosResponse = await this.$axios.delete(
        `${routeInfo.v2.routes}/${id}`
      );
      if (res.status !== 200) return;
      this.$bvModal.hide("route-info-v2-route-modal");

      const i = this.routes.findIndex((r) => r._id === id);
      if (i !== -1) this.routes.splice(i, 1);
      else this.fetchRoutes();
    } catch (e) {
      console.error(e);
    }
  }

  public async deleteCity(id: string): Promise<void> {
    const confirmed = await this.$bvModal.msgBoxConfirm(
      String(this.$t("route_info.confirm.deleteCity")),
      { title: String(this.$t("route_info.confirm.title")) }
    );
    if (confirmed !== true) return;
    try {
      const res: AxiosResponse = await this.$axios.delete(
        `${routeInfo.v2.cities}/${id}`
      );
      if (res.status !== 200) return;
      this.$bvModal.hide("route-info-v2-city-modal");

      const i = this.citis.findIndex((c) => c._id === id);
      if (i !== -1) this.citis.splice(i, 1);
      else this.fetchCities();
    } catch (e) {
      console.error(e);
    }
  }

  // --- Force delete (permanent) ---

  public async forceDeleteRoute(id: string): Promise<void> {
    const confirmed = await this.$bvModal.msgBoxConfirm(
      String(this.$t("route_info.confirm.deleteRouteForever")),
      { title: String(this.$t("route_info.confirm.title")) }
    );
    if (confirmed !== true) return;
    try {
      const res: AxiosResponse = await this.$axios.delete(
        `${routeInfo.v2.routes_force}/${id}`
      );
      if (res.status !== 200) return;
      this.$bvModal.hide("route-info-v2-route-modal");

      const i = this.routes.findIndex((r) => r._id === id);
      if (i !== -1) this.routes.splice(i, 1);
      else this.fetchRoutes();
    } catch (e) {
      console.error(e);
    }
  }

  public async forceDeleteCity(id: string): Promise<void> {
    const confirmed = await this.$bvModal.msgBoxConfirm(
      String(this.$t("route_info.confirm.deleteCityForever")),
      { title: String(this.$t("route_info.confirm.title")) }
    );
    if (confirmed !== true) return;
    try {
      const res: AxiosResponse = await this.$axios.delete(
        `${routeInfo.v2.cities_force}/${id}`
      );
      if (res.status !== 200) return;
      this.$bvModal.hide("route-info-v2-city-modal");

      const i = this.citis.findIndex((c) => c._id === id);
      if (i !== -1) this.citis.splice(i, 1);
      else this.fetchCities();
    } catch (e) {
      console.error(e);
    }
  }

  // --- Activate route ---

  private stripRoute(r: Route): Partial<Route> {
    const { update_history, metadata, createdAt, updatedAt, deleted, ...rest } =
      r as any;
    return rest;
  }

  public async activateRoute(id: string): Promise<void> {
    if (this.isActivating) return;

    const uri = routeInfo.v2.routes;
    const target = this.routes.find((r) => r._id === id);
    if (!target) return;

    this.isActivating = true;
    this.activateCancel?.abort();
    const controller = new AbortController();
    this.activateCancel = controller;

    try {
      if (target.status === "active") {
        const res = await this.$axios.put(
          `${uri}/${id}`,
          { ...this.stripRoute(target), status: "inactive" },
          { signal: controller.signal as any }
        );
        if (res.status === 200) {
          const idx = this.routes.findIndex((r) => r._id === id);
          if (idx !== -1) this.$set(this.routes, idx, res.data);
        }
        return;
      }

      // Deactivate all currently active routes
      const activeRoutes = this.routes.filter((r) => r.status === "active");
      await Promise.all(
        activeRoutes.map((r) =>
          this.$axios.put(
            `${uri}/${r._id}`,
            { ...this.stripRoute(r), status: "inactive" },
            { signal: controller.signal as any }
          )
        )
      );

      // Refresh local state for deactivated routes
      activeRoutes.forEach((r) => {
        const idx = this.routes.findIndex((x) => x._id === r._id);
        if (idx !== -1)
          this.$set(this.routes, idx, { ...r, status: "inactive" });
      });

      // Activate the selected route
      const res = await this.$axios.put(
        `${uri}/${id}`,
        { ...this.stripRoute(target), status: "active" },
        { signal: controller.signal as any }
      );
      if (res.status === 200) {
        const idx = this.routes.findIndex((r) => r._id === id);
        if (idx !== -1) this.$set(this.routes, idx, res.data);
      }
    } catch (e: any) {
      if (e?.name !== "CanceledError" && e?.name !== "AbortError") {
        console.error(e);
      }
    } finally {
      this.isActivating = false;
    }
  }

  // --- Restore from trash ---

  public async restoreRoute(id: string): Promise<void> {
    try {
      const res: AxiosResponse<Route> = await this.$axios.put(
        `${routeInfo.v2.routes_restore}/${id}`
      );
      if (res.status !== 200) return;

      const index = this.routes.findIndex((r) => r._id === id);
      if (index !== -1) this.routes.splice(index, 1);
      else this.fetchRoutes();
    } catch (e) {
      console.error(e);
    }
  }

  public async restoreCity(id: string): Promise<void> {
    try {
      const res: AxiosResponse<CityFeature> = await this.$axios.put(
        `${routeInfo.v2.cities_restore}/${id}`
      );
      if (res.status !== 200) return;

      const i = this.citis.findIndex((c) => c._id === id);
      if (i !== -1) this.citis.splice(i, 1);
      else this.fetchCities();
    } catch (e) {
      console.error(e);
    }
  }
}
export default RouteInfoV2;
